import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import PmiTextField from 'shell/components/shared/text-field';

interface AssentSonDataNewProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
}

const AssentSonDataComponentNew = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: AssentSonDataNewProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Assenso reso dinanzi a *"
          aria-label="Assenso reso dinanzi a"
          id="consentReturnedBefore"
          name="consentReturnedBefore"
          fullWidth
          disabled={disabled}
          helperText={errors?.consentReturnedBefore}
          error={touched?.consentReturnedBefore && Boolean(errors?.consentReturnedBefore)}
          type="text"
          variant="outlined"
          value={values?.consentReturnedBefore || ''}
          onChange={(event) => {
            onChange('consentReturnedBefore', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

AssentSonDataComponentNew.displayName = 'Form Assent Son Data component';

const AssentSonDataNew = memo(AssentSonDataComponentNew);

export default AssentSonDataNew;
